(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-remove-controls"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cart-remove-controls]');
    if (!root) return;

    const rows = Array.from(document.querySelectorAll('[data-cart-section] .cart-items__row'));
    const links = Array.from(root.querySelectorAll('[data-cart-remove-link]'));

    links.forEach((link) => {
      const index = Number(link.dataset.cartLineIndex);
      const row = rows[index];
      const details = row?.querySelector('.cart-item__details');
      if (!details) return;

      const quantityInput = row.querySelector('.cart-quantity-input');
      if (quantityInput) {
        const removeAtZero = (event) => {
          if (Number(quantityInput.value) !== 0) return;
          event.stopPropagation();
          quantityInput.setCustomValidity('');
          window.location.assign(link.href);
        };
        quantityInput.addEventListener('input', removeAtZero);
        quantityInput.addEventListener('change', removeAtZero);
      }

      const fallbackItem = link.closest('.cart-remove-controls__item');
      details.appendChild(link);
      if (fallbackItem) fallbackItem.remove();
    });

    if (!root.querySelector('[data-cart-remove-link]')) root.hidden = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    if (window.aboaCartLiveUpdateInitialized) return;
    window.aboaCartLiveUpdateInitialized = true;

    const timers = new WeakMap();
    const pendingInputs = new Set();
    const sectionQueues = new WeakMap();

    const formatMoney = (cents, currency) => {
      const code = currency || 'USD';
      return `${new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: code
      }).format(Number(cents || 0) / 100)} ${code}`;
    };

    const setStatus = (section, message) => {
      const status = section.querySelector('[data-cart-live-status]');
      if (status) status.textContent = message || '';
    };

    const getState = (section) => {
      const inputs = Array.from(section.querySelectorAll('.cart-quantity-input[data-wholesale-moq]'));
      let valid = true;

      inputs.forEach((input) => {
        const minimum = Number(input.dataset.wholesaleMoq || 6);
        const increment = Number(input.dataset.wholesaleIncrement || minimum);
        const quantity = Number(input.value);
        const inputValid = Number.isSafeInteger(quantity) && Number.isSafeInteger(minimum) && minimum > 0 && increment === minimum && quantity >= minimum && quantity % minimum === 0;
        const errorMessage = section.dataset.moqError || 'Quantities must be multiples of the MOQ.';
        input.setCustomValidity(inputValid ? '' : `${errorMessage} (MOQ: ${minimum}; allowed: ${minimum}, ${minimum * 2}, ${minimum * 3}…)`);
        if (!inputValid) valid = false;
      });

      const busy = section.dataset.cartUpdating === 'true' || inputs.some((input) =>
        pendingInputs.has(input) || Number(input.value) !== Number(input.dataset.savedQuantity)
      );
      return { valid, busy, inputs };
    };

    const updateRequestState = (section) => {
      const state = getState(section);
      const requestButton = section.querySelector('[data-request-button]');
      if (requestButton) {
        requestButton.disabled = !state.valid || state.busy;
        requestButton.setAttribute('aria-disabled', requestButton.disabled ? 'true' : 'false');
      }
      return state;
    };

    const updateDisplayedPrices = (section, input, cart) => {
      const line = Number(input.dataset.cartLine);
      const item = cart.items[line - 1];
      const row = input.closest('.cart-items__row');
      const currency = cart.currency || section.dataset.cartCurrency || 'USD';

      if (row && item) {
        const lineTotal = row.querySelector('[data-cart-line-total]');
        const unitPrice = row.querySelector('[data-cart-unit-price]');
        if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price, currency);
        if (unitPrice) unitPrice.textContent = formatMoney(item.final_price, currency);
        input.value = item.quantity;
        input.dataset.savedQuantity = String(item.quantity);
      }

      const subtotal = section.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price, currency);
    };

    const updateQuantity = async (input) => {
      const section = input.closest('[data-cart-section]');
      if (!section) return;

      const state = updateRequestState(section);
      if (!state.valid) {
        pendingInputs.delete(input);
        updateRequestState(section);
        input.reportValidity();
        return;
      }

      const line = Number(input.dataset.cartLine);
      const quantity = Number(input.value);
      section.dataset.cartUpdating = 'true';
      input.disabled = true;
      setStatus(section, section.dataset.updatingLabel || '');
      updateRequestState(section);

      try {
        const response = await fetch(section.dataset.cartChangeUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ line, quantity })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || section.dataset.updateError || '');

        updateDisplayedPrices(section, input, cart);
        setStatus(section, section.dataset.updatedLabel || '');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (error) {
        input.value = input.dataset.savedQuantity || input.value;
        setStatus(section, error.message || section.dataset.updateError || '');
      } finally {
        pendingInputs.delete(input);
        input.disabled = false;
        delete section.dataset.cartUpdating;
        updateRequestState(section);
      }
    };

    const enqueueUpdate = (input) => {
      const section = input.closest('[data-cart-section]');
      if (!section) return;
      const previous = sectionQueues.get(section) || Promise.resolve();
      const next = previous.catch(() => {}).then(() => updateQuantity(input));
      sectionQueues.set(section, next);
    };

    document.addEventListener('input', (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('.cart-quantity-input')) return;
      const input = event.target;
      const section = input.closest('[data-cart-section]');
      if (!section) return;

      const existingTimer = timers.get(input);
      if (existingTimer) window.clearTimeout(existingTimer);

      const state = updateRequestState(section);
      if (!state.valid) {
        pendingInputs.delete(input);
        setStatus(section, section.dataset.moqError || '');
        updateRequestState(section);
        return;
      }

      setStatus(section, '');
      state.inputs.forEach((changedInput) => {
        if (Number(changedInput.value) === Number(changedInput.dataset.savedQuantity)) return;
        const priorTimer = timers.get(changedInput);
        if (priorTimer) window.clearTimeout(priorTimer);
        pendingInputs.add(changedInput);
        timers.set(changedInput, window.setTimeout(() => enqueueUpdate(changedInput), 350));
      });
      updateRequestState(section);
    });

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('.cart-quantity-input')) return;
      const section = event.target.closest('[data-cart-section]');
      if (!section) return;
      if (!updateRequestState(section).valid) event.target.reportValidity();
    });

    document.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches('.wholesale-order-form')) return;
      const section = event.target.closest('[data-cart-section]');
      if (!section) return;

      const state = updateRequestState(section);
      if (state.valid && !state.busy) return;

      event.preventDefault();
      if (!state.valid) {
        const firstInvalid = state.inputs.find((input) => !input.checkValidity());
        if (firstInvalid) {
          firstInvalid.reportValidity();
          firstInvalid.focus();
        }
      } else {
        setStatus(section, section.dataset.updatingLabel || '');
      }
    });

    document.querySelectorAll('[data-cart-section]').forEach((section) => {
      if (!updateRequestState(section).valid) setStatus(section, section.dataset.moqError || '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const updateWholesaleMoq = (form) => {
      const select = form.querySelector('[data-wholesale-variant-select]');
      const quantity = form.querySelector('[data-wholesale-quantity]');
      const display = form.querySelector('[data-wholesale-moq-display]');
      if (!quantity || !display) return;
      const source = select ? select.selectedOptions[0] : form.querySelector('input[name="id"][data-wholesale-moq]');
      const moq = Math.max(1, Number(source?.dataset.wholesaleMoq || quantity.min || 6));
      const increment = moq;
      quantity.min = String(moq);
      quantity.step = String(increment);
      const current = Number(quantity.value);
      if (!Number.isFinite(current) || current < moq || (current - moq) % increment !== 0) quantity.value = String(moq);
      display.textContent = `${display.dataset.moqLabel}: ${moq} ${display.dataset.moqSuffix}`;
    };

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-wholesale-variant-select]')) return;
      const form = event.target.closest('[data-wholesale-product-form]');
      if (form) updateWholesaleMoq(form);
    });

    document.querySelectorAll('[data-wholesale-product-form]').forEach(updateWholesaleMoq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-quick-order"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('[data-qo]').forEach(s=>{const q=s.querySelector('[data-qo-search]'),rows=[...s.querySelectorAll('[data-qo-row]')],qty=[...s.querySelectorAll('[data-qo-qty]')],status=s.querySelector('[data-qo-status]'),empty=s.querySelector('[data-qo-empty]'),buttons=[...s.querySelectorAll('[data-qo-add]')];const msg=t=>{if(status)status.textContent=t};const filter=()=>{const t=(q?.value||'').trim().toLowerCase();let n=0;rows.forEach(r=>{const ok=!t||(r.dataset.search||'').includes(t);r.hidden=!ok;if(ok)n++});if(empty)empty.hidden=n>0};const valid=i=>{const n=Number(i.value||0),m=Number(i.dataset.moq||6),ok=n===0||(Number.isInteger(n)&&n>=m&&(n-m)%6===0);i.setCustomValidity(ok?'':`Quantity must be 0 or at least ${m}, then increase in multiples of 6.`);return ok};const add=async()=>{let bad=null;const items=[];qty.forEach(i=>{if(!valid(i)){bad ||= i;return}const n=Number(i.value||0);if(n>0)items.push({id:Number(i.dataset.id),quantity:n})});if(bad){msg(bad.validationMessage);bad.reportValidity();bad.focus();return}if(!items.length){msg('Enter a quantity for at least one SKU.');return}buttons.forEach(b=>b.disabled=true);msg('Adding selected SKUs to cart...');try{const r=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})}),p=await r.json();if(!r.ok)throw new Error(p.description||p.message||'Unable to add selected items.');location.assign(s.dataset.cart||`${window.Shopify.routes.root}cart`)}catch(e){msg(e.message||'Unable to add selected items.');buttons.forEach(b=>b.disabled=false)}};q?.addEventListener('input',filter);qty.forEach(i=>i.addEventListener('input',()=>valid(i)));buttons.forEach(b=>b.addEventListener('click',add));s.querySelector('[data-qo-clear]')?.addEventListener('click',()=>{qty.forEach(i=>{i.value=0;i.setCustomValidity('')});msg('Quantities cleared.')});filter()})})();
  } catch(e) { console.error(e); }
})();
})();
